import { useState, useEffect } from "react";
import { CallBackProps } from "react-joyride";

export function useHomepageTour(hasAcceptedToS: boolean) {
  const [runTour, setRunTour] = useState(false);
  const [tourStepIndex, setTourStepIndex] = useState(0);

  useEffect(() => {
    if (!hasAcceptedToS) return;
    const hasSeenTour = localStorage.getItem("hasSeenHomepageTour");
    if (!hasSeenTour) {
      const timer = setTimeout(() => setRunTour(true), 1500);
      return () => clearTimeout(timer);
    }
  }, [hasAcceptedToS]);

  const handleJoyrideCallback = (data: CallBackProps) => {
    const { status, action, index, type } = data;
    const finishedStatuses = ["finished", "skipped"];

    if (action === "prev" && type === "step:after") {
      setTourStepIndex(index - 1);
      return;
    }
    if (action === "next" && type === "step:after") {
      setTourStepIndex(index + 1);
      return;
    }
    if (
      finishedStatuses.includes(status as string) ||
      action === "close" ||
      action === "skip"
    ) {
      setRunTour(false);
      setTourStepIndex(0);
      localStorage.setItem("hasSeenHomepageTour", "true");
    }
  };

  return { runTour, setRunTour, tourStepIndex, handleJoyrideCallback };
}
